import styled from 'styled-components'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { breakpoints } from '@/config/layout'

const StDescription = styled(Span)`
  ${({ theme }) => `
    padding: 0 ${theme.UI.SpacingPx.Space4};

    @media ${breakpoints.m} {
      padding: 0 ${theme.UI.SpacingPx.Space14};
    }
  `}
`

export { StDescription }
